import { atom } from "jotai";
import {
    AVAILABLE_LANGUAGE,
    DEFAULT_LANG,
    getLangFromUrl,
    I18nRecord,
    STATIC_TRANSLATIONS,
} from "../i18n/config";
import { Platform } from "react-native";
import { getLocales } from "expo-localization";

const locales = getLocales();

const get_default_lang = () => {
    // On web, react-navigation reads `window.location` directly and never calls the linking
    // `getInitialURL()`, so a deeplink's `?lang=` has to be picked up here. Doing it at atom
    // creation also means the very first render is already in the right language.
    if (Platform.OS === "web" && typeof location !== "undefined") {
        const url_lang = getLangFromUrl(location.href);
        if (url_lang) {
            return url_lang;
        }
    }

    const device_lang = locales?.[0]?.languageCode;
    if (device_lang && AVAILABLE_LANGUAGE.includes(device_lang || "")) {
        return device_lang;
    }
    return DEFAULT_LANG;
};
export const currentLang = atom(get_default_lang());

export const currentTranslations = atom<Record<string, I18nRecord>>(STATIC_TRANSLATIONS);
